export const isMlEntitlementEnabled = (value) => value === 0 || value === "0";

export const isAiAnnotationAllowed = (value) => value !== 1;

export const isFeatureEnabled = (value) => value === 1 || value === "1";

export const resolveBulkUploadMode = ({ bulkUpload } = {}) => isFeatureEnabled(bulkUpload) ? "regular" : null;
